// @core/api/endpoints/platform/cancel_platform_invitation.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/platform';

/**
 * Cancel platform invitation
 * Cancels a pending invitation before it is accepted or declined. The invitation link will no longer be valid.
 */
export async function CancelPlatformInvitation(
  platform_id: string,
  invitation_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id/invitations/:invitation_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  requestPath = requestPath.replace(':invitation_id', encodeURIComponent(invitation_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
